export default __webpack_public_path__ + "static/media/details-1.c4851740.jpeg";